<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" sm="1">
                <v-btn-icon
                    icon="$oss-chevron-left"
                    class="back_btn"
                    size="large"
                    @click="$router.push({ name: 'companyactivities-table' })"
                >
                </v-btn-icon>
            </v-col>
            <v-col cols="12" sm="11">
                <h1>{{ name }}</h1>
                <h2>{{ description }}</h2>
            </v-col>
        </v-row>

        <v-row class="mt-5">
            <v-col>
                <p>Validez les comptes comptables</p>
                <Suggestions
                    v-if="activity"
                    :suggestions="activity.suggestions"
                    @change-status="onChangeStatus"
                />
            </v-col>
        </v-row>
    </v-container>
</template>

<script lang="ts">
import { Apollo } from "@/decorators";

import COMPANY_ACTIVITY from "../../graphql/CompanyActivity.gql";
import UPDATE_SUGESTION_STATUS from "../../graphql/admin/UpdateCompanyActivitySuggestion.gql";

import Suggestions from "./Suggestions.vue";

import { CompanyActivity } from "../../types/prisma.types";
import { Component, Vue, toNative } from "vue-facing-decorator";

@Component({
    components: {
        Suggestions,
    },
})
export class CompanyActivityDetails extends Vue {
    // activeSelectTag: boolean = false

    get companyActivityID() {
        return this.$route.params.id;
    }

    get name() {
        return this.activity?.name || "";
    }

    get description() {
        return this.activity?.description || "";
    }

    @Apollo({
        query() {
            return COMPANY_ACTIVITY;
        },
        variables() {
            return {
                id: this.companyActivityID,
            };
        },
        skip() {
            return !this.companyActivityID;
        },
        specificResult({ data, loading, networkStatus }: any) {
            this.loadingDocument = loading;
            if (!loading) {
                if (data) {
                    this.activity = data.companyActivity;
                }
            }
        },
    })
    activity: CompanyActivity = null;

    async onChangeStatus(data) {
        await this.$apollo.mutate({
            mutation: UPDATE_SUGESTION_STATUS,
            variables: data,
        });
    }
}

export default toNative(CompanyActivityDetails);
</script>
